/** 浮动电价(新) /metering/bill/float-price（floatPrice.vue） */
export default {
  floatPriceBillPage: {
    phDateStart: '开始日期',
    phDateEnd: '结束日期',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    sortDefault: '默认排序',
    selectedLine: '已选择 <span class="count">{count}</span> 条数据',
    sectionTitle: '浮动电价列表',
    btnCreateFloat: '浮动电价',
    colRid: '流水号',
    colFloatRange: '浮动区间',
    colFloatType: '浮动类型',
    colBillDate: '账单日期',
    colTargetPrice: '目标电价(尖/峰/平/谷)',
    colFloatAmount: '浮动金额',
    colCreator: '创建人',
    colCreateTime: '创建时间',
    colDetail: '详情',
    btnDetail: '详情',
    floatTypeGlobal: '整体浮动',
    floatTypePart: '部分浮动',
    unitYuan: '元',
    emptyNoViewPerm: '暂无查看权限',
    drawerTitleCreate: '浮动电价',
    drawerTitleDetail: '浮动电价详情',
    panelSelectTenant: '选择租户',
    panelTenantTier: '租户层级',
    panelTenantList: '租户列表',
    phSelectTenantTier: '请选择租户层级',
    phSearchTenant: '搜索租户…',
    tenantAll: '全部租户',
    tenantListEmpty: '暂无匹配租户',
    cardBasicConfig: '基础配置',
    lblDateRange: '时间区间',
    phStartTime: '开始时间',
    phEndTime: '结束时间',
    rangeTo: '至',
    lblFloatType: '浮动类型',
    phFloatType: '请选择浮动类型',
    btnQueryUsage: '查询用电数据',
    tipQueryPrereq: '请先选择租户、时间区间和浮动类型',
    cardUsageStats: '用电数据统计',
    statsRecords: '共 {count} 条记录',
    statsSelected: '，已选 {count} 条',
    cardPriceFloat: '电价浮动设置',
    colTenantName: '租户名称',
    colPartName: '电表名/公摊组名',
    colBindType: '类型',
    colPeakKwh: '尖电量(kWh)',
    colTopKwh: '峰电量(kWh)',
    colFlatKwh: '平电量(kWh)',
    colValleyKwh: '谷电量(kWh)',
    colSettledAmount: '已结金额(元)',
    colTargetAmount: '目标金额(元)',
    colFloatAmountYuan: '浮动金额(元)',
    lblPeakPrice: '尖时电价',
    lblTopPrice: '峰时电价',
    lblFlatPrice: '平时电价',
    lblValleyPrice: '谷时电价',
    unitPerKwh: '元/kWh',
    phPriceZero: '0.00000',
    lblBillDate: '账单日期',
    phBillDate: '请选择账单日期',
    lblRemark: '备注内容',
    phRemark: '请输入备注内容',
    btnCancel: '取消',
    btnConfirmCreate: '确定创建',
    btnClose: '关闭',
    detailBasicInfo: '基本信息',
    detailTargetPrice: '目标价格',
    detailFloatItems: '浮动明细',
    lblRid: '流水号：',
    detailLblFloatType: '浮动类型：',
    lblCreateTime: '创建时间：',
    lblCreator: '创建人：',
    lblDateRangeDetail: '时间区间：',
    lblBillDateDetail: '账单日期：',
    lblTotalFloat: '总浮动余额：',
    detailRecordsCount: '共 {count} 条记录',
    colUseElecGroup: '用电量(kWh)',
    colSharp: '尖',
    colPeak: '峰',
    colFlat: '平',
    colValley: '谷',
    detailColAlready: '已结金额',
    detailColFloatAmt: '浮动金额',
    detailColTargetBal: '目标余额',
    bindTypeDedicated: '专用表',
    bindTypeShare: '公摊表',
    bindTypeFormula: '公式表',
    bindTypeUnknown: '未知',
    msgFetchFail: '获取数据失败',
    msgTenantListFail: '获取租户列表失败',
    msgNoCreatePerm: '暂无浮动电价操作权限',
    msgQuerySuccess: '查询成功',
    msgQueryFail: '查询失败',
    msgSubmitPriceInvalid: '尖/峰/平/谷电价不能同时为0，至少有一个值需大于0',
    msgCreateSuccess: '创建成功',
    msgCreateFail: '创建失败',
    msgNoViewPerm: '暂无查看权限',
    msgDetailFail: '获取详情失败',
    msgNoDataExport: '暂无数据可导出',
    msgExportOk: '成功导出{count}条数据！',
    msgExportOkSelected: '成功导出{count}条选中数据！',
    msgExportFail: '导出失败，请重试',
    expColRid: '流水号',
    expColRange: '浮动区间',
    expColFloatType: '浮动类型',
    expColBillDate: '账单日期',
    expColTarget: '目标电价(尖/峰/平/谷)',
    expColFloatAmt: '浮动金额(元)',
    expColCreator: '创建人',
    expColCreateTime: '创建时间',
    exportSheetName: '浮动电价',
    filePrefix: '浮动电价',
    // 导出（本页/选中/全部）统一文案
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    warnNoSelectedExport: '请先选择要导出的数据',
    successExported: '导出成功，共 {count} 条',
    successExportedLimit: '命中 {total} 条，单次最多导出 {count} 条，已导出前 {count} 条',
    exporting: '正在导出全部数据...'
  }
}
